import React, { useEffect, useState } from 'react'
import './WhyChooseus.css'
import { FaArrowRight } from 'react-icons/fa'

function WhyChooseus() {
  const [visiblePoints, setVisiblePoints] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisiblePoints(prev => {
        if (prev < 6) return prev + 1;
        clearInterval(timer);
        return prev;
      });
    }, 500); // Each point appears after 500ms

    return () => clearInterval(timer);
  }, []);

  const points = [
    {
      text: "Comprehensive shipping solutions for all your logistics needs"
    },
    {
      text: "Global network with connections to major ports worldwide"
    },
    {
      text: "Personalized customer service with dedicated account managers"
    },
    {
      text: "Timely deliveries with real-time tracking capabilities"
    },
    {
      text: "Competitive pricing and transparent fee structure"
    },
    {
      text: "Certified quality management systems ensuring reliability"
    }
  ];

  return (
    <div className="main-whychooseus-container">
      {/* Hero section with image and overlay text */}
      <div className="whychooseus-hero">
        <div className="whychooseus-overlay">
          <h1>Why Choose Us</h1>
        </div>
      </div>

      {/* White gap */}
      <div className="white-gap"></div>

      {/* Content section with points and video */}
      <div className="whychooseus-content-main">
        <div className="whychooseus-points">
          <div className="points-container">
            {points.map((point, index) => (
              <div
                key={index}
                className={`point-item ${index < visiblePoints ? 'visible' : ''}`}
              >
                <div className="point-arrow">
                  <FaArrowRight />
                </div>
                <div className="point-text">
                  {point.text}
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="whychooseus-video">
          {/* Video without controls, with autoplay and loop */}
          <div className="video-placeholder">
            <video 
              className='video-placeholder-vidio' 
              src='./Pics/whychooseus.mp4'
              autoPlay 
              muted 
              loop 
              playsInline
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default WhyChooseus
